import React, { useEffect, useState } from 'react';
import { useLanguage } from '../context/language';
import Footer from '../components/Footer';
import Logo from "../assets/logo.png";
import { useHistory, useLocation } from 'react-router-dom';
import { getAceiteTermos } from '../api/fastcoinService';
import Loading from '../assets/loading.gif';

export const ConsultaOrdemTermos = () => {
    const { translate } = useLanguage();
    const [orderInfo, setOrderInfo] = useState();
    const [loadingCheckTerms, setLoadingCheckterms] = useState(true);
    const [dataFormatada, setDataFormatada] = useState("");
    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
        translate();
    }, [translate, loadingCheckTerms]);

    useEffect(() => {
        let order_number = sessionStorage.getItem("order_no");

        function validarTermos() {
            getAceiteTermos(order_number)
                .then(res => {
                    //console.log(res);
                    if (res[0] !== undefined) {
                        let data = new Date(res[0].DATA);
                        setDataFormatada(data.toLocaleDateString() + " " + data.toLocaleTimeString() + " (UTC)");
                        setOrderInfo(res[0]);
                    } else {
                        setOrderInfo("Informação não enocontrada - Verifique o número da ordem na URL!");
                    }
                    setLoadingCheckterms(false);
                })
                .catch(err => {
                    console.log(err);
                    alert("Please talk with the administrator");
                })
        }
        if (order_number !== "") {
            validarTermos();
        }
    }, []);

    return (
        <div>
            <div className="container">
                <div className="container-main boxes center">
                    <div className="content-pix">
                        <div className="content col-content">
                            <div className="msg-pix">
                                {loadingCheckTerms ?
                                    <div className="centered-loading-terms-consulta">
                                        <img src={Loading} alt={"loading"} width="30px" height="30px" />
                                    </div>
                                    :
                                    <>
                                        {orderInfo !== undefined &&
                                            <>
                                                <p><b>Ordem:</b> {orderInfo.NUM_ORDER}</p>
                                                <p><b>CPF/CNPJ/DOC:</b> {orderInfo.NUM_DOC}</p>
                                                <p><b>IP:</b> {orderInfo.IP}</p>
                                                <p><b>Data:</b> {dataFormatada}</p>
                                            </>
                                        }
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                    <img src={Logo} alt={"Logo Fastcoin"} width="360px" style={{ marginTop: "5em" }} />
                </div>
            </div>
            <Footer />
        </div>
    )
}
